import styled from 'styled-components'
// icons
import DotsIconOrigin from '@mui/icons-material/MoreHorizOutlined'
// utils
import { size } from 'polished'

export const DotsIcon = styled(DotsIconOrigin)`
  && {
    position: absolute;
    right: 8px;
    top: 4px;
    cursor: pointer;
    ${size('24px')};
  }
`
